export default __webpack_public_path__ + "static/media/GoPaperLess.8a1a37f3.png";